import React          from "react";
import { Box, Typography } from "@mui/material";
import { useTheme }   from "@mui/material/styles";

// Warning icon SVG - no external dependency needed
const WarningIcon = ({ color }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);

// Close icon SVG
const CloseIcon = ({ color }) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18"/>
    <line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);

// Inline error shown on login page when role is missing or access is denied
// message  - error text to display
// onClose  - clears the error from parent state
const LoginError = ({ message, onClose }) => {
  const theme = useTheme();
  const t     = theme.custom;

  if (!message) return null;

  return (
    <Box
      sx={{
        display:      "flex",
        alignItems:   "flex-start",
        gap:          "12px",
        background:   "rgba(200, 64, 64, 0.08)",
        border:       "1px solid rgba(200, 64, 64, 0.25)",
        borderLeft:   "3px solid #c84040",
        borderRadius: "4px",
        padding:      "14px 16px",
        width:        "860px",
        maxWidth:     "100%",
        // Fade in smoothly
        animation:    "fadeIn 0.3s ease",
        "@keyframes fadeIn": {
          from: { opacity: 0, transform: "translateY(-6px)" },
          to:   { opacity: 1, transform: "translateY(0)" },
        },
      }}
    >
      {/* Warning icon */}
      <Box sx={{ flexShrink: 0, mt: "1px" }}>
        <WarningIcon color="#c84040" />
      </Box>

      {/* Error content */}
      <Box sx={{ flex: 1 }}>
        <Typography
          sx={{
            fontFamily:    "'DM Mono', monospace",
            fontSize:      "9px",
            letterSpacing: "0.16em",
            textTransform: "uppercase",
            color:         "#c84040",
            mb:            "4px",
          }}
        >
          Access Denied
        </Typography>

        <Typography
          sx={{
            fontSize:   "12px",
            color:      t.text2,
            fontWeight: 300,
            lineHeight: 1.6,
          }}
        >
          {message}
        </Typography>
      </Box>

      {/* Close button */}
      <Box
        onClick={onClose}
        sx={{
          flexShrink: 0,
          cursor:     "pointer",
          color:      t.text3,
          mt:         "2px",
          transition: "color 0.2s",
          "&:hover":  { color: t.text2 },
        }}
      >
        <CloseIcon color="currentColor" />
      </Box>
    </Box>
  );
};

export default LoginError;